import { call, takeEvery } from '@redux-saga/core/effects';
import { createAction } from 'redux-actions';
import { PATH_DELIMITER, SEMESTER_TOTAL_ENROLMENT_STATUS_PATH } from '../../../constant/Constant';
import { request } from '../../ApiModule';

const ACTION_EXCEL_DOWNLOAD = SEMESTER_TOTAL_ENROLMENT_STATUS_PATH + PATH_DELIMITER + 'ACTION_EXCEL_DOWNLOAD';

export const actionExcelDownload = createAction(ACTION_EXCEL_DOWNLOAD);

export function* semesterTotalEnrolmentStatusSagas() {
    yield takeEvery(ACTION_EXCEL_DOWNLOAD, actionExcelDownloadSaga);
}

function* actionExcelDownloadSaga({ payload: { params } }) {
    yield call(request, {
        method: 'get',
        url: `/api/enrolment/semesters/${params.semesterId}/total-excel-export`,
        params,
        download: true,
        downloadDirect: true,
        downloadType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
}

export default module;
